export default __webpack_public_path__ + "img/selected.727a71a3.svg";